import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { GrFacebookOption } from 'react-icons/gr';
import { RiLinkedinFill } from 'react-icons/ri';
import { AiOutlineInstagram } from 'react-icons/ai';
import WhatsAppButton from '../Components/whatsappButton'; 
import logo from '../images/weblogo.png';
import { FaTelegramPlane } from "react-icons/fa";
import '../index.css'; // Ensure to import the CSS for the hover effect

const Footer = () => {
  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    };

    // Attach scrollToTop function to all anchor tags
    const links = document.querySelectorAll('a[href^="/"]');
    links.forEach(link => {
      link.addEventListener('click', scrollToTop);
    });

    // Clean up event listeners when the component unmounts
    return () => {
      links.forEach(link => {
        link.removeEventListener('click', scrollToTop);
      });
    };
  }, []);

  return (
    <footer className="relative bg-blueGray-200 pt-8 pb-6 mt-8">
      <div className="mx-auto px-4">
        <div className="flex flex-wrap text-left lg:text-left">
          <div className="w-full lg:w-6/12 px-4 relative">
            <Link to="/" className="absolute -top-14 text-xl md:text-2xl lg:text-2xl xl:text-2xl flex items-center">
              <img src={logo} alt="This is an image" className='w-10 -mt-4 mr-1 h-14' />
            </Link>
            <h5 className="text-lg mt-0 mb-2 text-blueGray-600">
              Find us on any of these platforms, we respond 1-2 business days.
            </h5>
            <div className="mt-6 lg:mb-0 mb-6 flex">
              <a
                href="https://web.facebook.com/profile.php?id=61561189633389"
                className="bg-white text-lightBlue-400 shadow-lg font-normal h-10 w-10 flex items-center justify-center rounded-full outline-none focus:outline-none mr-2"
              >
                <GrFacebookOption className='text-2xl' />
              </a>
              <a
                href="https://www.instagram.com/netsagetech/"
                className='bg-white text-lightBlue-600 shadow-lg h-10 w-10 flex items-center justify-center rounded-full outline-none focus:outline-none mr-2'
              >
                <AiOutlineInstagram className='text-2xl' />
              </a>
              <a
                href="https://t.me/netsagetechnologies"
                className='bg-white text-lightBlue-600 shadow-lg h-10 w-10 flex items-center justify-center rounded-full outline-none focus:outline-none mr-2'
              >
                <FaTelegramPlane className='text-2xl' />
              </a>
              {/* WhatsApp button component */}
              <div className='text-2xl text-lightBlue-600'>
                <WhatsAppButton />
              </div>
            </div>
          </div>
          <div className="w-full lg:w-6/12 px-4">
            <div className="flex flex-wrap items-top mb-6">
              <div className="w-full lg:w-4/12 px-4 ml-auto">
                <span className="block uppercase text-blueGray-500 text-sm font-semibold mb-2">Company</span>
                <ul className="list-unstyled">
                  <li>
                    <Link to='/' className="link-underline text-gray-600 hover:text-blueGray-800 block pb-2 text-sm">Home</Link>
                  </li>
                  <li>
                    <Link to="/about" className="link-underline text-gray-600 hover:text-blueGray-800 block pb-2 text-sm">About</Link>
                  </li>
                  <li>
                    <Link to="/contact" className="link-underline text-gray-600 hover:text-blueGray-800 block pb-2 text-sm">Contact</Link>
                  </li>
                </ul>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <span className="block uppercase text-blueGray-500 text-sm font-semibold mb-2">Services and Solutions</span>
                <ul className="list-unstyled">
                  <li>
                    <Link to="/logo-designing" className="link-underline text-gray-600 hover:text-blueGray-800 block pb-2 text-sm">Logo Designing</Link>
                  </li>
                  <li>
                    <Link to="/product-flyer" className="link-underline text-gray-600 hover:text-blueGray-800 block pb-2 text-sm">Product Flyers</Link>
                  </li>
                  <li>
                    <Link to="/graphic-designing" className="link-underline text-gray-600 hover:text-blueGray-800 block pb-2 text-sm">Graphic Designing</Link>
                  </li>
                  <li>
                    <Link to="/web-development" className="link-underline text-gray-600 hover:text-blueGray-800 block pb-2 text-sm">Web Development</Link>
                  </li>
                  <li>
                    <Link to="/app-development" className="link-underline text-gray-600 hover:text-blueGray-800 block pb-2 text-sm">App Development</Link>
                  </li>
                  <li>
                    <Link to="/see-all" className="link-underline text-gray-600 hover:text-blueGray-800 block pb-2 text-sm">Software Development</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <hr className="my-6 border-blueGray-300" />
        <div className="flex flex-wrap items-center md:justify-between justify-center">
          <div className="w-full md:w-4/12 px-4 mx-auto text-center">
            <div className="text-sm text-blueGray-500 font-semibold py-1">
              Copyright © <span id="get-current-year">2024</span>
              <Link to="/about" className="text-blueGray-500 hover:text-gray-800" target="_blank" rel="noopener noreferrer"> Created By</Link>
              <Link to={'/about'} className="text-blueGray-500 hover:text-blueGray-800"> Netsage</Link>.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
